// extracted by mini-css-extract-plugin
module.exports = {"container":"copy_container__1CTj2","copyIcon":"copy_copyIcon__2vCsX","active":"copy_active__IGD0T"};